<app-tasksfilter class="flex-control flex-column scroll-browser" [patient]="patient" [isPatientProfile]="true"></app-tasksfilter>
